import { useState, useEffect } from 'react';

/** Seconds since `startedAt`, ticking once a second while `running`. */
export function useCallTimer(startedAt: number | null, endedAt: number | null, running: boolean): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!running) return undefined;
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [running]);

  if (!startedAt) return 0;
  return Math.max(0, Math.round(((endedAt ?? now) - startedAt) / 1000));
}
